/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartSimulationRequestBody
 */
export interface StartSimulationRequestBody {
    /**
     * 
     * @type {Array<number>}
     * @memberof StartSimulationRequestBody
     */
    priceUnitIds: Array<number>;
    /**
     * 
     * @type {Date}
     * @memberof StartSimulationRequestBody
     */
    planningDate: Date;
    /**
     * 
     * @type {string}
     * @memberof StartSimulationRequestBody
     */
    versionName: string;
}

/**
 * Check if a given object implements the StartSimulationRequestBody interface.
 */
export function instanceOfStartSimulationRequestBody(value: object): value is StartSimulationRequestBody {
    if (!('priceUnitIds' in value) || value['priceUnitIds'] === undefined) return false;
    if (!('planningDate' in value) || value['planningDate'] === undefined) return false;
    if (!('versionName' in value) || value['versionName'] === undefined) return false;
    return true;
}

export function StartSimulationRequestBodyFromJSON(json: any): StartSimulationRequestBody {
    return StartSimulationRequestBodyFromJSONTyped(json, false);
}

export function StartSimulationRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartSimulationRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'priceUnitIds': json['priceUnitIds'],
        'planningDate': (new Date(json['planningDate'])),
        'versionName': json['versionName'],
    };
}

export function StartSimulationRequestBodyToJSON(json: any): StartSimulationRequestBody {
    return StartSimulationRequestBodyToJSONTyped(json, false);
}

export function StartSimulationRequestBodyToJSONTyped(value?: StartSimulationRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceUnitIds': value['priceUnitIds'],
        'planningDate': (formatDateOnly(value['planningDate'])),
        'versionName': value['versionName'],
    };
}

